// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import layer from 'vue-layer'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueKindEditor from 'vue-kindeditor'
import 'kindeditor/kindeditor-all-min.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'kindeditor/themes/default/default.css'
import './assets/style/common.css'
import animated from 'animate.css' 
import '../static/iconfont/iconfont.css'
// Vue.use(axios)
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueKindEditor);
Vue.use(animated);
Vue.use(ElementUI);

Vue.prototype.$layer = layer(Vue);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
/* eslint-disable no-new */
  Vue.prototype.setCookie = function(cname, cvalue) {
      // var d = new Date();
//         d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//         var expires = "expires=" + d.toUTCString();
//         console.info(cname + "=" + cvalue + "; " + expires);
        document.cookie = cname + "=" + escape(cvalue);
//         console.info(document.cookie);
  };
Vue.prototype.getCookie = function(name) {
  let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
};
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js